<template>
  <VaNavbar class="app-layout-navbar py-0 px-0 shadow padding-nav">
    <template #left>
      <div class="left" style="width: 1000px">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/velocity/" aria-label="Visit home page">
          <VuesticLogo :height="90" :width="140" class="mr-8" />
        </RouterLink>
        <div
          v-if="!isMobile && !auth.isExternal"
          class="ml-4 h-full flex items-center py-5 cursor-pointer"
          :class="{ 'active-tab': page === 'dashboard' }"
          @click="setPage('dashboard')"
        >
          <div class="px-4 font-16" :class="{ 'active-box': page === 'dashboard' }" style="cursor: pointer">
            <!-- <i
              class="va-icon vuestic-iconset vuestic-iconset-dashboard mr-1"
              aria-hidden="true"
              notranslate=""
              style="font-size: 14px; height: 10px; line-height: 20px"
            ></i> -->
            Dashboard
          </div>
        </div>
        <div
          v-if="!isMobile && !auth.isExternal"
          class="py-5 cursor-pointer"
          :class="{ 'active-tab ative-box': page === 'reputation' }"
          @click="setPage('reputation')"
        >
          <div class="px-4 font-16" :class="{ 'active-box': page === 'reputation' }" style="cursor: pointer">
            <!-- <i
              class="va-icon material-icons mr-1"
              aria-hidden="true"
              notranslate=""
              style="color: var(--va-secondary); font-size: 16px; height: 22px; line-height: 20px"
              >group</i
            > -->
            Reputation
          </div>
        </div>
        <div
          v-if="!isMobile && (auth.isAllowedIspMonitor || auth.isExternal)"
          class="py-5 cursor-pointer"
          :class="{ 'active-tab ative-box': page === 'inbox-monitor' }"
          @click="setPage('inbox-monitor')"
        >
          <div class="px-4 font-16" :class="{ 'active-box': page === 'inbox-monitor' }" style="cursor: pointer">
            <!-- <i
              class="va-icon material-icons mr-1"
              aria-hidden="true"
              notranslate=""
              style="color: var(--va-secondary); font-size: 16px; height: 22px; line-height: 20px"
              >group</i
            > -->
            Inbox Monitor
          </div>
        </div>

        <!-- <ToggleDark /> -->
      </div>
    </template>
    <template #right>
      <div class="flex items-center gap-4">
        <!-- <ThemeSwitcher /> -->
        <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
      </div>
    </template>
  </VaNavbar>
  <!-- <SecondaryNav v-if="!isMobile" /> -->
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../NetcoreLogoBlack.vue'
// import ToggleDark from '@/components/ToogleDark.vue'
import { RouterLink, useRouter } from 'vue-router'
// import ThemeSwitcher from '@/pages/settings/theme-switcher/ThemeSwitcher.vue'
// import { useDomainStore } from '@/stores/dashBoardStore.js'
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const { push } = useRouter()
const auth = useAuthStore()
const page = ref('')
const router = useRouter()
const currentRoute = router.currentRoute.value
const currentPath = currentRoute.path
console.log('cuurent path : ', currentPath)

const setPage = (value) => {
  page.value = value
  push({ name: value })
}

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
onMounted(() => {
  page.value = currentPath.toLowerCase().replace(/^\/|\/$/g, '')
})
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}

.padding-nav {
  padding-left: 5%;
  padding-right: 5%;
}

.active-tab {
  border-bottom: 2px solid #143f93;
}

.active-box {
  border-radius: 5px;
  color: #143f93;
  font-weight: 500;
}

.deactive-border {
  border-bottom: 2px solid inherit;
}

.font-16 {
  font-size: 16px;
}
</style>
